import React, { useEffect, useMemo, useCallback } from "react";
import { Route, Routes, useLocation, useNavigate, Navigate } from "react-router-dom";
import { APP_ROUTES, ROUTE_PATHS } from "../../constants/app.constants";
import Header from "./Header";
import NetworkAccessPage from "../distributor-settings/network-access";
import useActions from "../../hooks/service-actions.hook";
import { MspDetailsEffectActions } from "../../common/services/msp-details/msp-details.service";
import { useEntity } from "../../hooks/use-entity.hook";
import { Entities } from "../../common/store/entities/entities.enum";
import ImageLoader from "../Common/ImageLoader";
import CompanySettings from "../distributor-settings/company-settings";
import NavigationTabs from "../distributor-settings/network-access/navigation-tabs";
import MembersAccessPage from "../distributor-settings/members-access";
import TagsPage from "../distributor-settings/tags";
import SubscriptionsPage from "../distributor-settings/subscriptions";
import EmailTemplatesPage from "../distributor-settings/email-templates";
import "./index.styles.scss";
import StatusesPage from "../hg-settings/statuses";

const DistributorSettingsRoutes = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const  { getMspDetails } = useActions(MspDetailsEffectActions);
  const { mspId } = location.state || {};
  const { entityData: mspDetails } = useEntity({ entityType: Entities.MspDetails, entityId: mspId });

  useEffect(() => {
    if (!mspId) return;
    getMspDetails({ mspId });
  }, [mspId]);

  const leftSideComponent = (
    <div className="ml-4 d-flex align-items-center">
      <h3 className="m-0 f-14 line-height-22">Distributor Settings</h3>
    </div>
  )

  const currentPath = location.pathname;
  
  const onTabClick = useCallback((route) => {
    if (route) {
      navigate(route, { state: location.state });
    }
  }, [navigate, location.state]);
  
  const navigationTabs = useMemo(() => [
    { label: "Company Settings", active: currentPath === ROUTE_PATHS.subscriptionPortalPages.distributorSettingsCompanySettings, disabled: false, route: ROUTE_PATHS.subscriptionPortalPages.distributorSettingsCompanySettings, onClick: () => onTabClick(ROUTE_PATHS.subscriptionPortalPages.distributorSettingsCompanySettings) },
    { label: "Members and Access", active: currentPath === ROUTE_PATHS.subscriptionPortalPages.distributorSettingsMembersAccess, disabled: false, route: ROUTE_PATHS.subscriptionPortalPages.distributorSettingsMembersAccess, onClick: () => onTabClick(ROUTE_PATHS.subscriptionPortalPages.distributorSettingsMembersAccess) },
    { label: "Tags", active: currentPath === ROUTE_PATHS.subscriptionPortalPages.distributorSettingsTags, disabled: false, route: ROUTE_PATHS.subscriptionPortalPages.distributorSettingsTags, onClick: () => onTabClick(ROUTE_PATHS.subscriptionPortalPages.distributorSettingsTags) },
    { label: "Statuses", active: currentPath === ROUTE_PATHS.subscriptionPortalPages.distributorSettingsStatuses, disabled: false, route: ROUTE_PATHS.subscriptionPortalPages.distributorSettingsStatuses, onClick: () => onTabClick(ROUTE_PATHS.subscriptionPortalPages.distributorSettingsStatuses) },
    { label: "Network Access", active: currentPath === ROUTE_PATHS.subscriptionPortalPages.distributorSettingsNetworkAccess, disabled: false, route: ROUTE_PATHS.subscriptionPortalPages.distributorSettingsNetworkAccess, onClick: () => onTabClick(ROUTE_PATHS.subscriptionPortalPages.distributorSettingsNetworkAccess) },
    { label: "Email Templates", active: currentPath === ROUTE_PATHS.subscriptionPortalPages.distributorSettingsEmailTemplates, disabled: false, route: ROUTE_PATHS.subscriptionPortalPages.distributorSettingsEmailTemplates, onClick: () => onTabClick(ROUTE_PATHS.subscriptionPortalPages.distributorSettingsEmailTemplates) },
  ], [currentPath, onTabClick]);

  return (
    <div id="body-container-id" className="body-container hide-scrollbar">
      <Header isLoading={false} accountId={undefined} data={undefined} leftSideComponent={leftSideComponent} />

      <div className="nab-tabs-container">
        <NavigationTabs tabs={navigationTabs} />
      </div>

      <Routes>
        <Route path={APP_ROUTES.subscriptionPortalPages.distributorSettingsNetworkAccess} element={<NetworkAccessPage />} />
        <Route path={APP_ROUTES.subscriptionPortalPages.distributorSettingsCompanySettings} element={<CompanySettings />} />
        <Route path={APP_ROUTES.subscriptionPortalPages.distributorSettingsMembersAccess} element={<MembersAccessPage />} />
        <Route path={APP_ROUTES.subscriptionPortalPages.distributorSettingsSubscriptions} element={<SubscriptionsPage />} />
        <Route path={APP_ROUTES.subscriptionPortalPages.distributorSettingsTags} element={<TagsPage />} />
        <Route path={APP_ROUTES.subscriptionPortalPages.distributorSettingsStatuses} element={<StatusesPage />} />
        <Route path={APP_ROUTES.subscriptionPortalPages.distributorSettingsEmailTemplates} element={<EmailTemplatesPage />} />
        <Route path="" element={<Navigate to={ROUTE_PATHS.subscriptionPortalPages.distributorSettingsCompanySettings} replace />} />
        <Route path="*" element={<Navigate to={ROUTE_PATHS.subscriptionPortalPages.overview} replace />} />
      </Routes>
    </div>
  );
}

export default DistributorSettingsRoutes;
